module.exports = __webpack_public_path__ + "static/media/contact.c45cabd1.jpg";